import { api } from '../api/client.js';

export const SUBSCRIPTION_BILLING_PAGE_PATH = '/app/mensalidade';

/** @param {number} tenantId */
export function subscriptionBillingPayPath(tenantId) {
  const id = Number(tenantId);
  if (!Number.isFinite(id) || id <= 0) return SUBSCRIPTION_BILLING_PAGE_PATH;
  return `${SUBSCRIPTION_BILLING_PAGE_PATH}?billing=pay&tenant=${id}`;
}

/**
 * Abre checkout Mercado Pago da mensalidade em aberto da empresa.
 * @param {number} tenantId
 * @returns {Promise<string>} URL do checkout
 */
export async function openSubscriptionPayment(tenantId) {
  const rowId = Number(tenantId);
  if (!Number.isFinite(rowId) || rowId <= 0) {
    throw new Error('Empresa inválida para pagamento.');
  }
  const res = await api(`/tenants/${rowId}/subscription/pay-open`, { method: 'POST' });
  const url = res?.init_point;
  if (!url || typeof url !== 'string') {
    throw new Error('Resposta da API sem URL de checkout Mercado Pago.');
  }
  return url;
}

/** @param {unknown} value */
export function formatSubscriptionAmount(value) {
  const n = typeof value === 'number' ? value : Number(String(value ?? '').replace(',', '.'));
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n);
}

/** @param {unknown} ymd */
export function formatDueDateBr(ymd) {
  const raw = String(ymd ?? '').slice(0, 10);
  const parts = raw.split('-');
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return raw || '—';
}
